import { get } from '.';

export async function getBarchartGainers() {
	const symbols: any = (await get(`/barchart/gainers`)).data;

	return symbols;
}
